// extracted by mini-css-extract-plugin
export default {"cls1":"eT4aTvqNyb1B6IrmzaZE","cls2":"qMXtiOnwu2oszkyRwr0V eT4aTvqNyb1B6IrmzaZE","isPhone":"Tf1__jbfzuH4yqqXseA9"};